import { render } from "./Distributors.vue?vue&type=template&id=0e97eccf"
import script from "./Distributors.vue?vue&type=script&lang=js"
export * from "./Distributors.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__